import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledToolTip,
  StyledToolTipText,
} from './styles';

const ToolTip = ({
  text, className, children, disabled,
}) => {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <StyledToolTip className={className}>
      {children}
      <StyledToolTipText>{text}</StyledToolTipText>
    </StyledToolTip>
  );
};

ToolTip.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

ToolTip.defaultProps = {
  className: null,
  disabled: false,
};

export default ToolTip;
